import { render, staticRenderFns } from "./ProductAddedToList.vue?vue&type=template&id=2a6be3e0"
import script from "./ProductAddedToList.vue?vue&type=script&lang=js"
export * from "./ProductAddedToList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports